var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataConfig__content"},[_c('source-group',{attrs:{"is-delete":true,"is-add":true},on:{"data-source-skip":_vm.skipTo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }